<template>
  <div id="app">
    <Nav v-if="$route.path!='/pdfPreview'"></Nav>
    <router-view />
    <Footer v-if="$route.path!='/pdfPreview'"></Footer>
  </div>
</template>
<script>
import Nav from "@/components/nav.vue";
import Footer from "@/components/footer.vue";
export default {
  components: {
    Nav,
    Footer,
  },
};
</script>
<style lang="less">
*{
  margin:0;
  padding:0;
  box-sizing: border-box;
}
img{
  display: flex;
}
</style>
